import React, { useState } from 'react';
import { Translate as t } from '../../config/Translate';
import { formatDisplayYearMonth } from '../../lib/dateDisplay';
import WorkScheduleOverrideEditor from './WorkScheduleOverrideEditor';

const DAY_KEYS = ['common.day.sun', 'common.day.mon', 'common.day.tue', 'common.day.wed', 'common.day.thu', 'common.day.fri', 'common.day.sat'];

const WorkScheduleMonthView = ({ yearMonth, overrides, onAdd, onDelete, onPrev, onNext, isLoading }) => {
	const [showAddModal, setShowAddModal] = useState(false);

	const formatOverrideDate = (dateStr) => {
		if (!dateStr) return '';
		const d = new Date(dateStr + 'T00:00:00');
		const day = d.getDate();
		const dow = d.getDay();
		return `${day}(${t(DAY_KEYS[dow])})`;
	};

	const formatOverrideTime = (override) => {
		if (override.isOff) {
			return t('user.workSchedule.overrideTypeOff');
		}
		if (override.timeSlots && override.timeSlots.length > 0) {
			return override.timeSlots.map(s => `${s.start}~${s.end}`).join(', ');
		}
		return t('user.workSchedule.overrideTypeChange');
	};

	const handleAddSave = (data) => {
		onAdd(data);
		setShowAddModal(false);
	};

	const displayMonth = formatDisplayYearMonth(yearMonth, { fallback: '' });

	return (
		<div className="card mb-2">
			<div className="card-header d-flex justify-content-between align-items-center">
				<button className="btn btn-sm btn-outline-secondary" onClick={onPrev}>
					<ion-icon name="chevron-back-outline"></ion-icon>
				</button>
				<strong>{displayMonth}</strong>
				<button className="btn btn-sm btn-outline-secondary" onClick={onNext}>
					<ion-icon name="chevron-forward-outline"></ion-icon>
				</button>
			</div>
			<div className="card-body">
				<div className="d-flex justify-content-between align-items-center mb-2">
					<h6 className="mb-0">{t('user.workSchedule.override')}</h6>
					<button
						className="btn btn-sm btn-outline-primary"
						onClick={() => setShowAddModal(true)}
					>
						+ {t('user.workSchedule.overrideAdd')}
					</button>
				</div>

				{(!overrides || overrides.length === 0) ? (
					<p className="text-muted small mb-0">{t('user.workSchedule.noChanges')}</p>
				) : (
					<ul className="list-group list-group-flush">
						{overrides.map((ov) => (
							<li key={ov._id} className="list-group-item d-flex justify-content-between align-items-center px-0">
								<div>
									<span className="fw-bold">{formatOverrideDate(ov.date)}</span>
									{' : '}
									<span>{formatOverrideTime(ov)}</span>
									{ov.reason && <span className="text-muted ms-2">({ov.reason})</span>}
								</div>
								<button
									className="btn btn-sm btn-outline-danger"
									onClick={() => onDelete(ov._id)}
									disabled={isLoading}
								>
									<ion-icon name="close-outline"></ion-icon>
								</button>
							</li>
						))}
					</ul>
				)}
			</div>

			<WorkScheduleOverrideEditor
				show={showAddModal}
				onClose={() => setShowAddModal(false)}
				onSave={handleAddSave}
				isLoading={isLoading}
			/>
		</div>
	);
};

export default WorkScheduleMonthView;
